import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as actionsUsuarios from '../usuarios/redux/actions';
//import queryString from 'query-string';

export class UsuarioConfirmacao extends Component {
  static propTypes = {
    pages: PropTypes.object.isRequired,
    usuarios: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    actionsUsuarios: PropTypes.object.isRequired,
  };

  state = {
    tokenConfirmacao: '',
  };

  componentDidMount = () => {
    try {
      //const { token } = queryString.parse(this.props.location.search);
      var search = this.props.location.search;
      const token = search.substring(7, search.length);
      this.setState({ tokenConfirmacao: token });
      this.props.actionsUsuarios.confirmarCadastroPorToken(token, (action) => {
        if (action === 'USUARIOS_CONFIRMAR_CADASTRO_POR_TOKEN_SUCCESS') {

        }
      })
    } catch (error) {
      this.props.history.push(`/login`);
    }
  }
  render() {
    const { usuarios, usuarios: { registro } } = this.props;

    return (
      <div className="pages-usuario-confirmacao">
        {
          usuarios.registro.statusCode === 400 ?
            (
              <p>{registro.message}</p>
            )
            :
            (
              registro.Codigo && (
                <React.Fragment>
                  <h2>Email confirmado!</h2>
                  <p>Em breve você receberá um email de primeiro acesso. Verifique sua caixa de mensagem</p>
                </React.Fragment>
              )
            )
        }

      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pages: state.pages,
    usuarios: state.usuarios,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    actionsUsuarios: bindActionCreators({ ...actionsUsuarios }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UsuarioConfirmacao);



// WEBPACK FOOTER //
// ./src/features/pages/UsuarioConfirmacao.js